import { render, staticRenderFns } from "./BookingGuestMerge.vue?vue&type=template&id=483c87c8&scoped=true"
import script from "./BookingGuestMerge.vue?vue&type=script&lang=js"
export * from "./BookingGuestMerge.vue?vue&type=script&lang=js"
import style0 from "./BookingGuestMerge.vue?vue&type=style&index=0&id=483c87c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483c87c8",
  null
  
)

export default component.exports